exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".LX__a__self {\n  color: #263fff;\n  text-decoration: none;\n}\n\n.LX__a__bold {\n  font-weight: bold;\n}\n", "", {"version":3,"sources":["/apps/packages/components/src/a.scss"],"names":[],"mappings":"AAAA;EACE,eAAc;EACd,sBAAqB;CACtB;;AAED;EACE,kBAAiB;CAClB","file":"a.scss","sourcesContent":[".self {\n  color: #263fff;\n  text-decoration: none;\n}\n\n.bold {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"self": "LX__a__self",
	"bold": "LX__a__bold"
};